var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from '../../Modal';
import { openRequestTemplateModal } from '@project/store/createAppFlow/actions';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { useDispatch, useSelector } from 'react-redux';
var RequestTemplate = function () {
    var dispatch = useDispatch();
    var requestTemplate = useSelector(selectAppCreationFlow).requestTemplate;
    return (_jsx(Modal, __assign({ size: "small", open: requestTemplate, onClose: function () { return dispatch(openRequestTemplateModal(false)); } }, { children: _jsx("iframe", { src: "https://pages.upsales.com/7430u560dba45cf834a52a53862c20f4a62ac-frame", width: "100%", height: "575" }) })));
};
export default RequestTemplate;
